import { render } from "./BillingCard.vue?vue&type=template&id=96771174&scoped=true"
import script from "./BillingCard.vue?vue&type=script&lang=js"
export * from "./BillingCard.vue?vue&type=script&lang=js"

import "./BillingCard.vue?vue&type=style&index=0&id=96771174&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-96771174"

export default script